import { useEffect, useState } from 'react';
import { Button, Col, Container, Row, Table } from 'react-bootstrap';
import { Pencil } from 'react-bootstrap-icons';

import api from '../../services/api';
import './customer.css';
import { useNavigate } from 'react-router-dom';

const Customers: React.FC = () => {
  const [customers, setCustomers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await api.get('/users');
        setCustomers(response.data);
      } catch (error) {
        console.error('Error fetching customers:', error);
      }
    };
    fetchCustomers();
  }, []);

  const userDetail = (userId: number) => {
    navigate(`/dashboard/customers/${userId}/details`);
  };

  return (
    <Container>
      <Row className="h-100">
        <Row className="mt-4 align-items-center">
          <Col>
            <h4>Clientes</h4>
          </Col>
          <Col className="actions">
            <Button className="btn-custom" onClick={() => navigate('/dashboard/customers/new')}>
              +Nuevo
            </Button>
          </Col>
        </Row>
        <Table responsive striped bordered hover className="mt-4">
          <thead>
            <tr>
              <th>Nombre(s)</th>
              <th>Apellidos</th>
              <th>Email</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {customers.map((customer: any) => (
              <tr key={customer.userId}>
                <td>{customer.profile.firstName}</td>
                <td>{customer.profile.lastName}</td>
                <td>{customer.profile.email}</td>
                <td style={{ whiteSpace: 'nowrap', width: '1%' }}>
                  <Button
                    variant="light"
                    size="sm"
                    className=""
                    onClick={() => userDetail(customer.userId)}
                  >
                    <Pencil />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Row>
    </Container>
  );
};

export default Customers;
